module.exports = __webpack_public_path__ + "img/bg-solution-right-header.0864922a.png";